import { memo } from "react";
import { Button } from "antd";
import { useTranslation } from "react-i18next";
import classname from "classname";
import { UpCircleOutlined } from "@ant-design/icons";
import PropTypes from "prop-types";

const Upgrade = ({ id, title, icon, type, onClick, className, ...props }) => {
  const { t } = useTranslation();
  const btnTitle = title ? title : t("button.upgrade");
  return (
    <Button
      className={classname("flex items-center hover:opacity-70", className)}
      style={
        !props?.disabled
          ? { backgroundColor: "#46be8a", borderColor: "#6ccba2" }
          : {}
      }
      id={id}
      type={type}
      icon={icon}
      onClick={onClick}
      {...props}
    >
      {btnTitle}
    </Button>
  );
};

Upgrade.propTypes = {
  type: PropTypes.string,
  icon: PropTypes.object,
  title: PropTypes.string,
  onClick: PropTypes.func,
  id: PropTypes.string,
};

Upgrade.defaultProps = {
  type: "primary",
  icon: <UpCircleOutlined />,
  onClick: () => {},
  id: "btn-upgrade",
};

export default memo(Upgrade);
